export default __webpack_public_path__ + "e870a6d834ea41e967adade53659f609.svg";